import ScheduleAppointment from "./Screens/ScheduleAppointment/reducer"
import UserStats from "./Screens/Homepage/reducer"
import NewAppointment from './Screens/NewAppointment/reducer'
export default { 
    appointment_: ScheduleAppointment,
    userStats:UserStats,
    appointment:NewAppointment
} 

